export const abilitiesListES = [
  {
    id: "1",
    title: "Análisis y Resolución de Problemas",
    desc: "Analizar los problemas, manteniendo la calma y la lucidez frente a ellos. Encontrar y aplicar con rapidez soluciones prácticas, también mediante la reflexión íntima y enfoques alternativos.",
    value: "",
    name: "analysis_problem_solving",
  },
  {
    id: "2",
    title: "Innovación",
    desc: "Idear, introducir e implementar nuevas metodologías, nuevos sistemas, nuevos servicios y nuevos productos, con un enfoque de mejora y evolutivo respecto al pasado. Producir ideas originales y superar las dificultades con aportaciones originales. Discutir el status quo mediante visiones alternativas.",
    value: "",
    name: "innovation",
  },
  {
    id: "3",
    title: "Visión Estratégica",
    desc: "Aislar los objetivos generales y decisivos, identificando las guías generales y los medios para alcanzarlos, considerando la potencial evolución de las situaciones tanto a corto como a largo plazo. Formular, si fuera necesario, visiones innovadoras y alternativas. Saber transmitir de forma eficaz la visión y estrategia a los demás.",
    value: "",
    name: "strategic_thinking",
  },
  {
    id: "4",
    title: "Orientación al Cliente",
    desc: "Relacionarse con el cliente de forma atenta, empática y proactiva, comprendiendo sus exigencias, explícitas e implícitas, dándoles valor y convirtiéndolas en oportunidades. Establecer y gestionar relaciones constructivas con distintos clientes, internos y externos, orientando sus solicitudes.",
    value: "",
    name: "customer_orientation",
  },
  {
    id: "5",
    title: "Liderazgo",
    desc: "Situarse como punto de referencia dentro de un grupo y proporcionar a los demás una guía clara, mediante un estilo de liderazgo enérgico y carismático. Guiar al grupo hacia el objetivo común, asumiendo la responsabilidad del proyecto y de las personas.",
    value: "",
    name: "leadership",
  },
  {
    id: "6",
    title: "Trabajo en Equipo",
    desc: "Colaborar activamente con los demás para compartir los objetivos y alcanzarlos. Fomentar el intercambio y el debate, gestionando  potenciales conflictos de forma constructiva, dedicando atención a generar un espíritu de equipo. Compartir las ideas propias demostrando  interés por las contribuciones ajenas.",
    value: "",
    name: "team_work",
  },
  {
    id: "7",
    title: "Orientación al Resultado",
    desc: "Manifestar determinación, luchando a fondo para alcanzar objetivos ambiciosos. No rendirse frente a las adversidades, atesorando los fracasos. En este proceso, proceder de forma sistemática para continuar la actividad.",
    value: "",
    name: "result_orientation",
  },
  {
    id: "8",
    title: "Planificación y Organización",
    desc: "Planificar el trabajo anticipadamente y según una perspectiva a largo, medio y corto plazo. Entender los aspectos prioritarios de cada situación y gestionar, en consecuencia, los recursos disponibles. Proceder metódicamente y actuar de forma estructurada, definiendo y manteniendo en el tiempo los periodos operativos y los momentos de monitoreo y control.",
    value: "",
    name: "organization_plan",
  },
  {
    id: "9",
    title: "Gestión del Cambio",
    desc: "Mostrar curiosidad por el cambio, buscándolo y adaptándose rápidamente. Vivir las novedades con optimismo y fomentarlas activamente.",
    value: "",
    name: "change_management",
  },
  {
    id: "10",
    title: "Propensión al Desarrollo Personal",
    desc: "Activarse de forma proactiva, en primera persona, para perseguir un crecimiento profesional ambicioso, tanto en términos de competencias como de carrera profesional. Hacerse personalmente responsable del desarrollo propio y la actualización propios. Buscar activamente feedback y aceptarlo de forma constructiva. Mostrar curiosidad e interés hacia las oportunidades de aprendizaje, las novedades y la posibilidad de vivir nuevas experiencias.",
    value: "",
    name: "self_development",
  },
  {
    id: "11",
    title: "Gestión del Estrés",
    desc: "Mantener la eficiencia también bajo presión. Hacer frente a las situaciones importantes, difíciles o potencialmente evaluadoras con energía, continuidad y lucidez. Mantener la seguridad y sensación de eficiencia propias en situaciones indefinidas. Afrontar de forma eficaz las cargas de trabajo significativas.",
    value: "",
    name: "stress_management",
  },
];

export const abilitiesListPT = [
  {
    id: "1",
    title: "Análise e Resolução de Problemas",
    desc: "Analisar os problemas, mantendo a calma e a lucidez frente a eles. Encontrar e aplicar rapidamente soluções práticas, também através da reflexão íntima e de abordagens alternativas.",
    value: "",
    name: "analysis_problem_solving",
  },
  {
    id: "2",
    title: "Inovação",
    desc: "Idealizar, introduzir e implementar novas metodologias, novos sistemas, novos serviços e novos produtos, com foco em melhoria e evolução em relação ao passado. Produzir ideias originais e superar as dificuldades com contribuições originais. Discutir o status quo através de visões alternativas.",
    value: "",
    name: "innovation",
  },
  {
    id: "3",
    title: "Visão Estratégica",
    desc: "Isolar os objetivos gerais e decisivos, identificando as diretrizes gerais e os meios para alcançá-los, considerando a potencial evolução das situações a curto e longo prazo. Formular, se necessário, visões inovadoras e alternativas. Saber transmitir de forma eficaz a visão e a estratégia aos outros.",
    value: "",
    name: "strategic_thinking",
  },
  {
    id: "4",
    title: "Orientação ao Cliente",
    desc: "Relacionar-se com o cliente de forma atenciosa, empática e proativa, compreendendo suas exigências, explícitas e implícitas, dando-lhes valor e transformando-as em oportunidades. Estabelecer e gerenciar relacionamentos construtivos com diferentes clientes, internos e externos, orientando suas solicitações.",
    value: "",
    name: "customer_orientation",
  },
  {
    id: "5",
    title: "Liderança",
    desc: "Ser ponto de referência dentro de um grupo e fornecer orientação clara aos outros, através de um estilo de liderança enérgico e carismático. Guiar o grupo em direção ao objetivo comum, assumindo a responsabilidade do projeto e das pessoas.",
    value: "",
    name: "leadership",
  },
  {
    id: "6",
    title: "Trabalho em Equipe",
    desc: "Colaborar ativamente com os outros para compartilhar os objetivos e alcançá-los. Fomentar a troca e o debate, gerenciando potenciais conflitos de forma construtiva, dedicando atenção para gerar um espírito de equipe. Compartilhar as próprias ideias demonstrando interesse pelas contribuições alheias.",
    value: "",
    name: "team_work",
  },
  {
    id: "7",
    title: "Orientação para Resultados",
    desc: "Manifestar determinação, lutando profundamente para alcançar objetivos ambiciosos. Não se render diante das adversidades, valorizando os fracassos. Nesse processo, proceder de forma sistemática para continuar a atividade.",
    value: "",
    name: "result_orientation",
  },
  {
    id: "8",
    title: "Planejamento e Organização",
    desc: "Planejar o trabalho antecipadamente e de acordo com uma perspectiva de longo, médio e curto prazo. Compreender os aspectos prioritários de cada situação e gerenciar os recursos disponíveis de acordo. Proceder metodicamente e agir de forma estruturada, definindo e mantendo ao longo do tempo os períodos operacionais e os momentos de monitoramento e controle.",
    value: "",
    name: "organization_plan",
  },
  {
    id: "9",
    title: "Gestão da Mudança",
    desc: "Mostrar curiosidade pela mudança, buscando-a e se adaptando rapidamente. Viver as novidades com otimismo e promovê-las ativamente.",
    value: "",
    name: "change_management",
  },
  {
    id: "10",
    title: "Propensão ao Desenvolvimento Pessoal",
    desc: "Ativar-se de forma proativa, em primeira pessoa, para buscar um crescimento profissional ambicioso, tanto em termos de competências quanto de carreira profissional. Tornar-se pessoalmente responsável pelo próprio desenvolvimento e atualização. Buscar ativamente feedback e aceitá-lo de forma construtiva. Mostrar curiosidade e interesse nas oportunidades de aprendizado, nas novidades e na possibilidade de vivenciar novas experiências.",
    value: "",
    name: "self_development",
  },
  {
    id: "11",
    title: "Gestão do Estresse",
    desc: "Manter a eficiência também sob pressão. Lidar com situações importantes, difíceis ou potencialmente avaliativas com energia, continuidade e lucidez. Manter a segurança e sensação de eficiência pessoal em situações indefinidas. Enfrentar de forma eficaz as cargas de trabalho significativas.",
    value: "",
    name: "stress_management",
  },
];
